import { Component, EventEmitter, Input, OnInit, Output, OnDestroy } from '@angular/core';
import { HotkeyService } from '../../../UI-Lib/HotKeys/hotKeys.service';
import { UpgradeNavigationServiceHandler } from '../../../Common/Routing/upgrade-navigation-handler.service';
import { CompanyService } from '../../../Entity/Company/company.service';
import { DecimalPipe } from '@angular/common';
import { BusyIndicatorRef, BusyIndicatorService } from '../../../Busy-Indicator';
import { WeissmanModalService } from '../../../Compliance/WeissmanModalService';
import { RestrictService, Roles } from '../../../Common/Permissions/restrict.service';
import {
    MessageBoxButtons,
    MessageBoxOptions,
    MessageBoxResult,
    MessageBoxService
} from '../../../UI-Lib/Message-Box/messagebox.service.upgrade';
import { SiteRepository } from '../../../Core-Repositories';
import { ParcelService } from '../../../Entity/Parcel/parcel.service.upgrade';
import { GridApi, GridOptions, GridReadyEvent, ICellEditorParams } from 'ag-grid-community';
import { IncomeStatementAgGridDataSource, IncomeStatementDataSourceParams } from './agGridDataSource';
import { BehaviorSubject, lastValueFrom, Subject, Subscription } from 'rxjs';
import { BreadCrumb } from '../../../UI-Lib/Bread-Crumb/breadCrumbs.component';
import {
    AgGridOptionsBuilder
} from '../../../Compliance/AgGrid';
import {
    AgGridMultiSelectTracker
} from '../../../Compliance/AgGrid/MultiSelectTracker';
import { AgGridExportOptions, AgGridExportStartLRP } from '../../../Compliance/AgGrid/ToolPanel/models';
import * as _ from 'lodash';
import { takeUntil } from 'rxjs/operators';
import { IncomeStatementRepository } from '../incomeStatement.repository';
import { MessageModalService } from '../../../UI-Lib/Message-Box/messageModal.service';
import {
    DeleteConfirmationComponent,
    DeleteConfirmationComponentParams
} from '../../../Common/Delete-Confirmation/deleteConfirmation.component';
import {
    AgGridActionCellRendererParams
} from '../../../Compliance/AgGrid/CellRenderers/agGridActionCellRenderer.component';
import { GLAccountService } from '../../../Compliance/GL-Account/glAccount.service';
import LongRunningProcessTypeEnum = Compliance.LongRunningProcessTypeEnum;
import { WeissmanDateFormatPipe } from '../../../UI-Lib/Pipes';
import {
    IncomeStatementBulkUpdateComponent, IncomeStatementBulkUpdateParams
} from '../Income-Statement-Bulk-Update/incomeStatementBulkUpdate.component';
import { INCOME_STATEMENT_LIST_COLUMNS } from './incomeStatementList.columns';

@Component({
    selector: 'income-statement-list',
    templateUrl: './incomeStatementList.component.html',
    styleUrls: ['./incomeStatementList.component.scss'],
    providers: [HotkeyService],
    standalone: false
})
export class IncomeStatementListComponent implements OnInit, OnDestroy {
    constructor(
        public readonly decimalPipe: DecimalPipe,
        public readonly datePipe: WeissmanDateFormatPipe,
        private readonly _routerService: UpgradeNavigationServiceHandler,
        private readonly _incomeStatementRepository: IncomeStatementRepository,
        private readonly _companyService: CompanyService,
        private readonly _busyIndicatorService: BusyIndicatorService,
        private readonly _modalService: WeissmanModalService,
        private readonly _restrictService: RestrictService,
        private readonly _messageBoxService: MessageBoxService,
        private readonly _siteService: SiteRepository,
        private readonly _parcelService: ParcelService,
        private readonly _messageModalService: MessageModalService,
        private readonly _glAccountService: GLAccountService,
    ) {
    }

    @Input() companyIdFilter: number;
    @Input() siteIdFilter: number;
    @Input() parcelIdFilter: number;
    @Input() isEmbededMode: boolean = false;
    @Input() onLoading: boolean;
    @Output() onLoadingChange: EventEmitter<boolean> = new EventEmitter<boolean>();

    breadcrumbs: BreadCrumb[] = [];
    selectedTotalsLoading: boolean = true;
    companyId: number;
    newCompanyId: number;
    companyName: string;
    canEdit: boolean = false;
    canViewRyanPrivateItems: boolean = false;
    isInitialized: boolean = false;
    gridId: System.Guid = 'D705A9AA-2ACE-4831-82FE-09A712A451B7';
    isBulkUpdateVisible$: BehaviorSubject<boolean> = new BehaviorSubject(false);
    isBulkDeleteVisible$: BehaviorSubject<boolean> = new BehaviorSubject(false);
    busyRefId: string = this._busyIndicatorService.generateUniqueMessageIdentifier();
    filterHref: string;
    siteName: string;
    parcelName: string;
    selectedEndDate: Date;
    endDates: Date[];
    currentTotals: Core.IncomeStatementLineSearchTotalsModel;

    gridOptions: GridOptions = this._getGridOptions()
    gridTracker: AgGridMultiSelectTracker;
    exportOptions: AgGridExportOptions = this._getExportOptions();
    gridApi: GridApi;

    private _gridDataSource: IncomeStatementAgGridDataSource;
    private _gridMultiSelectSub: Subscription;
    private _busyRef: BusyIndicatorRef;
    private _destroy$: Subject<void> = new Subject();

    async ngOnInit(): Promise<void> {
        this.companyId = this.companyIdFilter ?? parseInt(this._routerService.getQuerystringParam('companyId'))

        if (!this.isEmbededMode && typeof this.siteIdFilter === 'undefined') {
            this.siteIdFilter = parseInt(this._routerService.getQuerystringParam('siteId'));
        }

        if (!this.isEmbededMode && typeof this.parcelIdFilter === 'undefined') {
            this.parcelIdFilter = parseInt(this._routerService.getQuerystringParam('parcelId'));
        }

        this.newCompanyId = this.companyId;

        let busyRef: BusyIndicatorRef;

        if (this.isEmbededMode) {
            this.onLoading = true;
            this.onLoadingChange.emit(true);

            if (typeof this.siteIdFilter !== 'undefined') {
                this.filterHref = this._routerService.getHrefFromState('siteIncomeStatement', {
                    companyId: this.companyId,
                    siteId: this.siteIdFilter
                });
            } else if (typeof this.parcelIdFilter !== 'undefined') {
                this.filterHref = this._routerService.getHrefFromState('incomeStatementParcelFilter', {
                    companyId: this.companyId,
                    parcelId: this.parcelIdFilter
                });
            }
        } else {
            busyRef = this._busyIndicatorService.show({ message: 'Loading' });
        }

        await this._initFromServer(busyRef);

        this._glAccountService.start(this.companyId);
        return Promise.resolve();
    }

    ngOnDestroy(): void {
        this._gridMultiSelectSub && this._gridMultiSelectSub.unsubscribe();
        this._destroy$.next();
        this._destroy$.complete();
    }

    get refreshing(): boolean {
        return this._gridDataSource && this._gridDataSource.isRefreshing;
    }

    async onAgGridReady(event: GridReadyEvent): Promise<void> {
        this.gridApi = event.api;
        this.gridApi.setGridOption("loading", true);

        this.gridTracker = new AgGridMultiSelectTracker(this.gridOptions, this.gridApi, this._getGridRowIds.bind(this));

        this._setGridColumns();

        // notify the bulk update button (on the column tool panel) every time the grid selection changes
        this._gridMultiSelectSub = this.gridTracker.selectedRows$.subscribe(async () => {
            const isBulkUpdateVisible = this.canEdit && this.gridTracker.hasSelectedRows();
            this.isBulkUpdateVisible$.next(isBulkUpdateVisible);
            this.isBulkDeleteVisible$.next(isBulkUpdateVisible);
        });

        this._setDataSource();
    }

    onEndDateChange(): void {
        this._refreshDataSource();
    }

    async refresh(): Promise<void> {
        await this._initEndDates();
        await this._refreshDataSource();
    }

    async bulkDelete(): Promise<void> {
        const confirmOptions = {
            message: 'Are you sure you want to delete selected line items?',
            buttons: MessageBoxButtons.OKCancel
        } as MessageBoxOptions;

        const result = await this._messageBoxService.open(confirmOptions);

        if(result !== MessageBoxResult.OK)  return;

        const params: DeleteConfirmationComponentParams = {
            item: 'Income Statement Line Items',
            message: 'Are you sure you want to delete selected line items? If you choose to proceed, all information related to line items will be removed and cannot be recovered.'
        };

        const shouldDelete = await this._modalService.showAsync(DeleteConfirmationComponent, params, 'modal-md');

        if (shouldDelete) {
            this._showBusyIndicator('Bulk Delete', 'Deleting line items', null, false, false);

            const model: Compliance.IncomeStatementLineBulkDeleteModel = {
                lastModifiedTimestamp: this._gridDataSource.lastModifiedTimestamp,
                selectAllRows: this.gridTracker.getSelectedRowsModel().selectAllRows,
                selectedRows: this.gridTracker.getSelectedRowsModel().selectedRows,
                siteId: this.siteIdFilter,
                endDate: this.selectedEndDate
            };

            try {
                const longRunningProcessId = await lastValueFrom(
                    this._incomeStatementRepository.startBulkDelete(this.companyId, model)
                );
                await this._busyRef.setLongRunningProcessId(longRunningProcessId);
            } catch (e) {
                await this._hideBusyIndicator();
                return Promise.reject(e);
            }
        }

        return Promise.resolve();
    }

    handleTotalsUpdate = (totals: Core.IncomeStatementLineSearchTotalsModel, selectedTotals: boolean = false) => {
        if (!selectedTotals) {
            this.currentTotals = totals;
        }
    };

    async bulkUpdate(): Promise<void> {
        const params: IncomeStatementBulkUpdateParams = {
            companyId: this.companyId,
            siteId: this.siteIdFilter,
            selection: this.gridTracker.getSelectedRowsModel(),
            selectedCount: this.gridTracker.getSelectedRowsCount(),
            endDate: this.selectedEndDate
        };

        const result = await this._modalService.showAsync(IncomeStatementBulkUpdateComponent, params, 'modal-md');

        if (!result) {
            return Promise.resolve();
        }

        this.gridTracker.clear();
        await this.refresh();
        const totals = await this._gridDataSource.getSelectedRowTotals({ selectedRows: [], selectAllRows: true });
        this.handleTotalsUpdate(totals);
    }

    async updateIsValidated(params: ICellEditorParams, updatedValue: boolean): Promise<void> {
        const data = params.data as Core.IncomeStatementLineModel;

        if (!data) {
            return Promise.resolve();
        }

        const initialValue = params.value;
        if (updatedValue === initialValue) {
            return Promise.resolve();
        }

        const updateModel: Core.IncomeStatementLineItemIsValidatedUpdateModel = {
            incomeStatementLineId: data.incomeStatementLineId,
            isValidated: updatedValue,
            rowVersion: data.rowVersion
        };

        const busyRef = this._busyIndicatorService.show({ message: 'Saving' });

        try {
            const result = await lastValueFrom(this._incomeStatementRepository.updateIsValidated(updateModel));
            data.isValidated = result.isValidated;
            data.validatedBy = result.validatedBy;
            data.validatedDate = result.validatedDate;
            data.rowVersion = result.rowVersion;
        } catch (e) {
            data.isValidated = initialValue;
            throw e;
        } finally {
            await busyRef.hide();
        }

        params.node.setData(data);

        return Promise.resolve();
    }

    async updateBalance(params: ICellEditorParams, updatedValue?: number): Promise<void> {
        const data = params.data as Core.IncomeStatementLineModel;

        if (!data) {
            return Promise.resolve();
        }

        const initialValue = params.value;
        if (updatedValue === initialValue) {
            return Promise.resolve();
        }

        const updateModel: Core.IncomeStatementLineBalanceUpdateModel = {
            incomeStatementLineId: data.incomeStatementLineId,
            balance: updatedValue,
            rowVersion: data.rowVersion
        };

        const busyRef = this._busyIndicatorService.show({ message: 'Saving' });

        try {
            data.rowVersion = await lastValueFrom(this._incomeStatementRepository.updateBalance(updateModel));
            data.calculatedBalance = updatedValue || data.importedBalance;
        } catch (e) {
            data.calculatedBalance = initialValue;
            throw e;
        } finally {
            await busyRef.hide();
        }

        params.node.setData(data);

        const totals = await this._gridDataSource.getSelectedRowTotals({ selectedRows: [], selectAllRows: true });
        this.handleTotalsUpdate(totals);

        return Promise.resolve();
    }

    async deleteItem(params: AgGridActionCellRendererParams): Promise<boolean> {
        const item = params.data as Core.IncomeStatementLineModel;

        if (!item) {
            return;
        }

        try {
            await this._messageModalService.confirm(
                `Are you sure you wish to delete ${item.glAccountName}?`,
                'Confirm'
            );
        } catch (e) {
            return Promise.resolve(false);
        }

        const busyRef = this._busyIndicatorService.show({ message: 'Deleting' });
        try {
            await lastValueFrom(this._incomeStatementRepository.deleteItem(item.incomeStatementLineId));
            await this._initEndDates();
            this.refresh();
            return Promise.resolve(true);
        } finally {
            busyRef.hide();
        }

    }

    private async _getGridRowIds(skip: number, take: number): Promise<Compliance.QueryResultModel<number>> {
        return this._gridDataSource.getRowIdsInternal(skip, take);
    }

    private async _refreshDataSource(): Promise<void> {
        if (!this._gridDataSource) {
            const success = this._setDataSource();
            if (!success) {
                return;
            }
        }

        this.gridTracker.clear(false);

        this.isBulkUpdateVisible$.next(false);
        this.isBulkDeleteVisible$.next(false);

        this._gridDataSource.clearTotals();

        this._gridDataSource.refresh();
    }

    private _setDataSource(): boolean {
        if (!this.gridApi || this._gridDataSource) {
            return false;
        }

        this.gridTracker.clear(false);

        this.isBulkUpdateVisible$.next(false);
        this.isBulkDeleteVisible$.next(false);

        const dataSourceParams = (): IncomeStatementDataSourceParams => {
            return {
                companyId: this.companyId,
                siteId: this.siteIdFilter,
                endDate: this.selectedEndDate
            };
        };

        this._gridDataSource = new IncomeStatementAgGridDataSource(
            this.gridApi,
            this._incomeStatementRepository,
            dataSourceParams,
            this.handleTotalsUpdate
        );

        this.gridApi.updateGridOptions({ datasource: this._gridDataSource });
        return true;
    }

    private _setGridColumns(): void {
        this.gridApi.setGridOption('columnDefs', []);
        const columns = INCOME_STATEMENT_LIST_COLUMNS(this);
        this.gridApi.setGridOption('columnDefs', columns);
        this.gridApi.setFilterModel(null);
    }

    private async _reloadTotals(): Promise<void> {
        if (!this._gridDataSource) {
            return;
        }

        this.selectedTotalsLoading = true;

        try {
            const result = await this._gridDataSource.getSelectedRowTotals(this.gridTracker.getSelectedRowsModel());
            this.selectedTotalsLoading = false;
            this.handleTotalsUpdate(result, true);
        } finally {
            this.selectedTotalsLoading = false;
        }
    }

    private _showBusyIndicator(title: string, message: string = 'Working on it...', lrpId: number, canDismiss = true, hasProgressBar = true): void {
        if (this._busyRef) {
            this._busyRef.updateMessage(message, this.busyRefId);
            this._busyRef.setLongRunningProcessId(lrpId);
            return;
        }

        this._busyRef = this._busyIndicatorService.show({
            identifier: this.busyRefId,
            longRunningProcessId: lrpId,
            title: title ? title : 'Processing',
            message: message,
            hasProgressBar: hasProgressBar,
            canDismiss
        });

        this._busyRef.onProgressBarComplete().pipe(takeUntil(this._destroy$)).subscribe(async (success) => {
            await this._hideBusyIndicator();
            if (success) {
                await this._initEndDates();
                await this.refresh();
            }
        });
    }

    private async _hideBusyIndicator(): Promise<void> {
        if (this._busyRef) {
            await this._busyRef.hide();
            this._busyRef = null;
        }
        this._destroy$.next();
    }

    private async _initEndDates() {
        this.endDates = await lastValueFrom(this._incomeStatementRepository.getIncomeStatementEndDates(this.companyId, this.siteIdFilter));

        if (!_.includes(this.endDates, this.selectedEndDate)) {
            this.selectedEndDate = _.maxBy(this.endDates, x => new Date(x));
        }
    }

    private _getGridOptions(): GridOptions {
        return new AgGridOptionsBuilder({
            onFilterChanged: () => this.gridTracker.onGridFilterChanged(),
            onSortChanged: () => this.gridTracker.onGridSortChanged(),
            rowClassRules: {
                'ag-row-selected': (params) => params.data && this.gridTracker.isRowSelected((params.data as Core.IncomeStatementLineModel).incomeStatementLineId),
                'totals-row': (params) => params.data && params.data.totalsRow,
                'selected-totals-row': (params) => params.data && params.data.selectedTotalsRow
            }
        })
        .withColumnPinning()
        .buildDefault(this);
    }

    private _getExportOptions(): AgGridExportOptions {
        return {
            start: async (columnsToReturn: Compliance.NameValuePair<string>[]): Promise<AgGridExportStartLRP> => {
                const searchParams = this._gridDataSource.getSearchParamsWithoutPagination();

                searchParams.selectedRows = this.gridTracker.getSelectedRowsModel();
                if (!searchParams.selectedRows.selectAllRows && searchParams.selectedRows.selectedRows.length === 0) {
                    searchParams.selectedRows.selectAllRows = true;
                }
                const exportModel: Compliance.IncomeStatementLineExportModel = {
                    searchModel: searchParams,
                    columnsToReturn: columnsToReturn,
                    selectedRows: searchParams.selectedRows
                };

                const lrp$ = this._incomeStatementRepository.startIncomeStatementLineExport(this.companyId, exportModel);
                const longRunningProcessId = await lastValueFrom(lrp$);
                return { longRunningProcessId, longRunningProcessTypeId: LongRunningProcessTypeEnum.IncomeStatementLine };
            },
            canCancel: true,
            showFileFormatSelection: false
        };
    }

    private async _initFromServer(busyRef: BusyIndicatorRef): Promise<void> {
        try {
            this.canEdit = await this._restrictService.hasCompanyPermission(this.companyId, Core.AccessRightsEnum.Write);
            this.canViewRyanPrivateItems = this._restrictService.isInRole(Roles.RYANPRIVATEITEMSVIEW);

            let sitePromise: Promise<void>;

            if (!this.isEmbededMode && this.siteIdFilter) {
                sitePromise = lastValueFrom(this._siteService.getSiteName(this.siteIdFilter)).then(result => {
                    this.siteName = result;
                });
            }

            let parcelPromise: Promise<void>;
            let parcelSiteId: number;

            if (!this.isEmbededMode && this.parcelIdFilter) {
                parcelPromise = this._parcelService.getView(this.parcelIdFilter, false).then(result => {
                    this.parcelName = result.parcel.acctNum;
                    parcelSiteId = result.siteId;
                });
            }

            const companyPromise = this._companyService.load(this.companyId, true, false);
            companyPromise.then((company) => {
                this.companyName = company.companyName;
            });

            await Promise.all([
                companyPromise,
                sitePromise,
                parcelPromise
            ]);

            this.breadcrumbs.push({
                name: this.companyName,
                target: 'company',
                options: { companyId: this.companyId }
            });

            if (this.siteName) {
                this.breadcrumbs.push({
                    name: this.siteName,
                    target: 'site',
                    options: { companyId: this.companyId, siteId: this.siteIdFilter }
                });
            }

            if (this.parcelName) {
                this.breadcrumbs.push({
                    name: this.parcelName,
                    target: 'parcel',
                    options: { companyId: this.companyId, siteId: parcelSiteId, parcelId: this.parcelIdFilter }
                });
            }

            await this._initEndDates();

            this.isInitialized = true;
        } finally {
            if (this.isEmbededMode) {
                this.onLoading = false;
                this.onLoadingChange.emit(false);
            } else {
                busyRef.hide();
            }
        }
    }
}
